import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#F58220] shadow-2xl flex items-center justify-center hover:scale-105 hover:bg-[#C7580A] transition-all duration-400"
        aria-label="chat"
      >
        {open ? <X className="w-5 h-5 text-white" /> : <MessageCircle className="w-6 h-6 text-white" />}
      </button>

      <div
        className={`fixed bottom-24 right-6 z-50 w-[320px] bg-white rounded-2xl shadow-2xl overflow-hidden transition-all duration-500 origin-bottom-right border border-[#E9D6C1] ${
          open ? 'scale-100 opacity-100' : 'scale-90 opacity-0 pointer-events-none'
        }`}
      >
        <div className="bg-[#1a1410] text-white p-5">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#F58220] flex items-center justify-center">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[15px] font-semibold">Veetu Saama</div>
              <div className="text-[11px] opacity-70">Typically replies in minutes</div>
            </div>
          </div>
        </div>
        <div className="p-5 bg-[#F7F4EA]">
          <div className="bg-white rounded-2xl rounded-tl-sm p-4 text-[14px] text-[#1a1410] shadow-sm border border-[#E9D6C1]">
            Hi! How can we help you find something for your home?
          </div>
          <a
            href="https://wa.me/917305970386"
            target="_blank"
            rel="noreferrer"
            className="btn-primary mt-5 w-full inline-flex items-center justify-center gap-2 py-3 rounded-full text-[11px] uppercase tracking-[0.24em]"
          >
            Start Chat <Send className="w-4 h-4" />
          </a>
        </div>
      </div>
    </>
  );
};

export default ChatWidget;
